let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5G4m5")).then(() => parcelRequire('fJGot'));